import { OpacityTokenValue } from 'designSystem/types';
import * as S from './styles';

interface OpacityTokenPreviewProps {
	value: OpacityTokenValue;
}

export const OpacityTokenPreview = ({ value }: OpacityTokenPreviewProps) => {
	return (
		<S.PreviewContainer>
			<S.OpacityBox opacity={value.value}>
				<S.OpacityOverlay opacity={value.value} />
			</S.OpacityBox>
		</S.PreviewContainer>
	);
};
